import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { formatDate, SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import TooltipComponent from "../../Components/TooltipComponent";
import { currentDateAndTime,decodeData, formatDateAndTime } from "../../Constants/constants";
import * as XLSX from 'xlsx'


class EmployeePMS extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      reporting_manager: '1',
      location_id: "",
      department_id: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSearch: false,
      loadingLogs: false,
      postLoading: false,
      loadingFilter: false,
      get_location_row: [],
      goals_rows: [],
      department_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      agency_verification_status: '',
      empOptions: [],
      emp_keyword: '',
      selected_rm_employee_id: '',
      reporting_manager_employee_id: '',
      assignGoalsModal: false,
      goal_id:"",
      goal_title:"",
      goal_description:"",
      from_date: '',
      to_date: '',
      pms_cycle_start_date: '',
      pms_cycle_end_date: '',
      pms_cycle_from_date: '',
      pms_cycle_to_date: '',
      errors: '',
      goal_assign_id: "",
      goal_rating_employee: "",
      goal_submit_remark: "",
      goal_status: "",
      sendGoalModal:false,
      viewEmployeeGoalsLogs:false,
      employeeGoalsRows: [],
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
    //   this.GetDepartmentMasters();
    //   this.GetEmployeesOptionList();
    //   this.GetLocationMasters();
      this.GetList();
    //   this.GetGoalsList();
    //   this.GetLocationList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
          console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              console.log("encodedData",encodedData);
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              console.log("decodedData",decodedData);
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
              }
          } else {
              console.warn("Permissions not yet available. Retrying...");
          }
      }
  }

  GetEmployeesOptionList = () => {
    if (this.state.emp_keyword) {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}PMSRouter/GetEmployeesOptionList`, { params: { keyword: this.state.emp_keyword }, headers })
          .then((response) => {
            if (response.data.success === true) {
              this.setState({ empOptions: response.data.data })
            } else {
              this.setState({ empOptions: [] })
            }
          })
      } catch (error) {
        console.log("error", error)
      }
    } else {
      console.log("no emp keyword")
    }
  }
  GetGoalsList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetGoalsList`, {
        params: {
          limit: 999,
          page: 1,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
            const tempRows= data?.data.map((val)=>{
                return { value: val?.goal_id, label: val?.goal_title }
            })
          this.setState({
            goals_rows: tempRows,
          });
        } else {
          this.setState({ loadingList: false, loadingSearch:false });
        }
      })
      .catch((error)=>{
        console.log(error);
      })
      .finally(this.setState({ loadingList: false, loadingSearch:false }));
      
  };
  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));

  };


  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            department_row: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetMyGoalsList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        }
        this.setState({ loadingList: false, loadingSearch:false, loadingFilter: false  });
      }).catch((error)=>{
        this.setState({ loadingList: false, loadingSearch:false, loadingFilter: false  });
        console.log(error);
        Swal.fire({ 
        title: `<strong>Failed</strong>`, 
        text: error?.message, 
        icon: 'error', 
        showConfirmButton: true,
        allowOutsideClick:false, 
        });
      })
  };

  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const errors = this.validateForm();
    console.log("SubmitMyGoalReview ERROR:",errors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors,postLoading:false });
      return;
    }
    const formData = {
        goal_assign_id: this.state.goal_assign_id || "",
        goal_rating_employee: this.state.goal_rating_employee,
        goal_submit_remark: this.state.goal_submit_remark,
    };
    axios.post(`${apiURL}PMSRouter/SubmitMyGoalReview`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ 
            postLoading:false,
            goal_id:'',
            goal_title:'',
            goal_start_date:'',
            goal_end_date:'',
            sendGoalModal:false,
            goal_assign_id: "",
            goal_rating_employee: "",
            goal_submit_remark: "",
         }, (prevState) => {
          this.GetList();
        })
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        this.setState({postLoading:false, })
      }
    }).catch((error)=>{
            console.log("ERROR",error);
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }).finally(this.setState({postLoading:false}));
  };

    validateForm = () => {
        const errors = {};
        if (!this.state.goal_submit_remark) errors.goal_submit_remark = 'Remark is required';    
        if (!this.state.goal_rating_employee) {
          errors.goal_rating_employee = 'Rating is required';
        }
        if (this.state.goal_rating_employee && (this.state.goal_rating_employee>100 || this.state.goal_rating_employee<0)) {
            errors.goal_rating_employee = `Rating ${this.state.goal_rating_employee>100? "cannot be more than 100":this.state.goal_rating_employee<0?"cannot be less than 0":"invalid"}.`;
        }
        return errors;
      };

  getInfo=(row)=>{
    this.setState({
        goal_id: row?.goal_id,
        goal_title: row?.goal_title || "",
        goal_description: row?.goal_description || "",
        pms_cycle_start_date: row?.cycle_from_date? formatDate(row?.cycle_from_date): '',
        pms_cycle_end_date: row?.cycle_to_date? formatDate(row?.cycle_to_date): '',
        pms_cycle_from_date: row.goal_start_date? formatDate(row.goal_start_date):'',
        pms_cycle_to_date:  row.goal_end_date? formatDate(row.goal_end_date):'',
        goal_rating_employee: row?.goal_rating_employee || '',
        goal_submit_remark: row?.goal_submit_remark || '',
        goalsModal:true,
    });
  }
  handleRating=(row)=>{
    this.setState({
        goal_id: row?.goal_id,
        goal_assign_id: row?.goal_assign_id,
        goal_title: row?.goal_title || "",
        pms_cycle_start_date: row?.cycle_from_date? formatDate(row?.cycle_from_date): '',
        pms_cycle_end_date: row?.cycle_to_date? formatDate(row?.cycle_to_date): '',
        pms_cycle_from_date: row.goal_start_date? formatDate(row.goal_start_date):'',
        pms_cycle_to_date:  row.goal_end_date? formatDate(row.goal_end_date):'',
        sendGoalModal:true,
        goal_rating_employee: row?.goal_rating_employee || '',
        goal_submit_remark: row?.goal_submit_remark || '',
    });
  }

  handleInputSearch = (e) => {
    this.GetList();
    //   this.GetLocationList();
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }),()=>{
        if(!value && name==="keyword"){
            this.GetList();
        }
    });
  };


  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action,row) => {
    Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to change status to ${action}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
    }).then((result) => {
        if (result.isConfirmed) {
            this.setState({ 
                goal_assign_id: row?.goal_assign_id || "",
                employee_id: row?.employee_id || "",
                goal_status: action==="Started"? "1":"2" },
            ()=> this.handleStatusSubmit());
    }});

  };

  handleStatusSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const formData = {
        goal_assign_id: this.state.goal_assign_id || "",
        employee_id: this.state.employee_id || "",
        goal_status: this.state.goal_status,
        date: currentDateAndTime(),
    };
    Swal.fire({
        title: 'Please wait...',
        html: 'Processing...',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
    axios.post(`${apiURL}PMSRouter/HandleMyGoalStatus`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ 
            postLoading:false,
            goal_status:'',
         }, (prevState) => {
          this.GetList();
        })
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        this.setState({postLoading:false, })
      }
    }).catch((error)=>{
            console.log("ERROR",error);
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }).finally(()=>{
            Swal.close();
            this.setState({postLoading:false});
        });
  };

  GetGoalsLogList = (row) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetAssignedGoalsLogs`, {
        params: {
            goal_assign_id: row?.goal_assign_id || "",
            employee_id: row?.employee_id || "",
            is_employee: "1",
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {           
          this.setState({
            employeeGoalsRows: data?.data,
            viewEmployeeGoalsLogs:true,
          });
        } else {
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }
      })
      .catch((error)=>{
        console.log(error);
        Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: 'Opps...! Something went wrong.', 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
      })
      .finally(this.setState({ loadingList: false, loadingLogs:false }));
      
  };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            get_location_row: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title
            }))
          }));
        }
      });
  }

  handleExcelDownload = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    Swal.fire({
        title: 'Please wait...',
        html: 'Your file is being prepared for download.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    axios.get(`${apiURL}PMSRouter/GetMyGoalsList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },headers
    }).then(async (response) => {
        // console.log("handleExcelDownload",response);
        if (response.data?.success === true) {
            const rows = response.data?.data;
            const data = rows.map(row => ({
                'Employee Code': row?.employee_code ? row?.employee_code : "-",
                'Employee Name': row?.employee_name ? row?.employee_name : "-",
                'Reporting Manager': row?.reporting_manager_name ? row?.reporting_manager_name : "-",
                'Assigned Date': row?.assigned_date? formatDate(row?.assigned_date):"--",
                'PMS Cycle': `${row?.cycle_from_date? formatDate(row?.cycle_from_date):""} To ${row?.cycle_to_date? formatDate(row?.cycle_to_date):""}`,
                'Goal Start Date': ` ${row?.goal_start_date ? formatDate(row?.goal_start_date) : "-"}`,
                'Goal End Date': `${row?.goal_end_date ? formatDate(row?.goal_end_date) : "-"}`,
                'Task Submitted Date': `${row?.goal_submitted_date ? formatDate(row?.goal_submitted_date) : "-"}`,
                'Goal Title': row?.goal_title ? row?.goal_title : "-",
                // 'Department': row?.department_title ? row?.department_title : "-",
                // 'Location': row?.location_title ? row?.location_title : "-",
                'Status': row?.GoalStatus ? row?.GoalStatus : "-",
                'Employee Rating': row?.goal_rating_employee ? row?.goal_rating_employee : "-",
                'RM Rating': row?.goal_rating_rm ? row?.goal_rating_rm : "-",
                'Grade': row?.goal_grade ? row?.goal_grade : "-",
                'Remark By Employee': row?.goal_submit_remark ? row?.goal_submit_remark : "-",
                'Remark By RM': row?.goal_rating_remarks_rm ? row?.goal_rating_remarks_rm : "-",
            }));

            const columns = [
                { header:  'Employee Code', key:  'Employee Code', width: 20 },
                { header:  'Employee Name', key:  'Employee Name', width: 20 },
                { header: 'Reporting Manager', key: 'Reporting Manager', width: 20 },
                { header: 'Assigned Date', key: 'Assigned Date', width: 20 },
                { header: 'PMS Cycle', key: 'PMS Cycle', width: 20 },
                { header: 'Goal Start Date', key: 'Goal Start Date', width: 20 },
                { header: 'Goal End Date', key: 'Goal End Date', width: 20 },
                { header: 'Task Submitted Date', key: 'Task Submitted Date', width: 20 },
                { header: 'Goal Title', key: 'Goal Title', width: 20 },
                // { header: 'Department', key: 'Department', width: 20 },
                // { header: 'Location', key: 'Location', width: 20 },
                { header: 'Status', key: 'Status', width: 20 },
                { header: 'Employee Rating', key: 'Employee Rating', width: 20 },
                { header: 'RM Rating', key: 'RM Rating', width: 20 },
                { header: 'Grade', key: 'Grade', width: 20 },
                { header: 'Remark By Employee', key: 'Remark By Employee', width: 20 },
                { header: 'Remark By RM', key: 'Remark By RM', width: 20 },
            ];

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
            ws['!cols'] = columns.map(column => ({ wch: column.width }));
            XLSX.utils.book_append_sheet(wb, ws, 'My Goals Report');

            // XLSX.writeFile(wb, `AbStartMyAttendanceReport_(${Date()}).xlsx`);
            const date=currentDateAndTime();
            XLSX.writeFile(wb, `My Goals Report ${formatDate(date)}.xlsx`);

            Swal.close();

            Swal.fire({
                title: '<strong>Success</strong>',
                html: 'Your file has been downloaded successfully.',
                icon: 'success'
            });
        } else {
            Swal.close();
            Swal.fire({
                title: '<strong>Error</strong>',
                html: response.data.message,
                icon: 'error'
            });
        }
    }).catch((error) => {
        Swal.close();
        Swal.fire({
            title: '<strong>Error</strong>',
            html: error.message,
            icon: 'error'
        });
    });
}

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {

    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };
  
  handleClearAll = () => {
    try{
      this.setState(
        {
          location_id: '',
          department_id: '',
          location_shift_id: '',
          reporting_manager_employee_id: '',
          keyword: "",
          rows: [],
          next: false,
          prev: false,
          page: 1,
          limit: 10,
          total_records: 0,
          total_pages: 0,
          loadingList: false,
          postLoading: false,
          from_date: "",
          to_date: "",
        },
        () => {
          this.GetList();
        }
      );
    } catch (error) {
      this.setState({ loadingFilter: false });
    }
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500,];

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`My Goals`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className='col-md-3'>
                        <label htmlFor="keyword">Search By Title</label>
                        <div className="input-group">
                          <input type="search" className="form-control" 
                          onChange={this.handleInputChange} name="keyword" 
                          value={this.state.keyword} aria-label="Recipient's username" 
                          aria-describedby="button-addon2" placeholder="Enter Title" />
                           {/* <TooltipComponent name="Search" position="bottom"> */}
                            <button className="btn btn-success" 
                            onClick={() => {
                                if (
                                  this.state.keyword &&
                                  !this.state.loadingSearch
                                ) {
                                  this.setState({
                                    loadingSearch:true
                                  },()=>{
                                    this.handleInputSearch();
                                  })
                                }
                              }}
                            type="button" id="button-addon2">
                            {this.state.loadingSearch ? (
                            <span class="spinner-border flex-shrink-0" role="status" 
                            style={{ width: "0.8rem", height: "0.8rem", borderWidth: "2px", }}>
                                <span class="visually-hidden">Loading...</span>
                            </span>
                            ) : (
                            <i className="ri-search-line"></i>
                            )}
                            </button>
                            {/* </TooltipComponent> */}
                        </div>
                      </div>
                       <div className='col-md-3'>
                            <TextBox type="Date" id="from_date" name="from_date" label="From Date" value={this.state.from_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-3'>
                            <TextBox type="Date" id="to_date" name="to_date" label="To Date" value={this.state.to_date} change={this.handleInputChange} />
                        </div>
                        {/* <div className='col-md-3'>
                            <div className=" d-flex align-items-center gap-2"> */}
                                <div className='col-lg-2 col-md-3 col-6 '>
                                  <div><label>Apply Filter</label></div>
                                  {/* <button
                                      type="button"
                                      onClick={this.handleInputSearch}
                                      disabled={ !this.state.from_date && !this.state.to_date}
                                      className={`w-100 noWrap btn btn-info btn-label waves-effect waves-light`}>
                                      <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                      Filter
                                  </button> */}
                                  <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                  disabled={!this.state.from_date && !this.state.to_date}
                                  loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                  buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                </div>
                                <div className='col-lg-2 col-md-3 col-6 '>
                                  <div><label className="noWrap">Clear Filter</label></div>
                                  {/* <button
                                      type="button"
                                      disabled={!this.state.from_date && !this.state.to_date}
                                      className={`w-100 btn noWrap btn-secondary btn-label waves-effect waves-light`}
                                      onClick={this.handleClearAll}
                                  >
                                    <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> 
                                    Clear
                                  </button> */}
                                  <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                  disabled={!this.state.from_date && !this.state.to_date}
                                  loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                  buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                </div>
                            {/* </div>
                        </div> */}
                        { this.state.decodedData?.includes(6) && ( 
                        // <div className='col-md-3'>
                        //     <div className=" d-flex align-items-center gap-2">
                                <div className='col-lg-2 col-md-3 col-6 '>
                                    <div><label>Export Excel</label></div>
                                    {/* <button
                                        type="button"
                                        onClick={this.handleExcelDownload}
                                        className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                        Export Excel
                                    </button> */}
                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                    disabled={this.state.rows.length === 0}
                                    buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                </div>
                        //     </div>
                        // </div>
                        )}
                        {/* <div className=" row mt-2">
                            <div className='col-md-3'>
                            <div>
                                <label>Assign Goal</label>
                            </div>
                            <button
                                type="button"
                                onClick={()=>{
                                    this.setState({assignGoalsModal:true});
                                }}
                                // ${(this.state.selectedRows.length === 0) ? 'disabled' : ''}
                                className={`btn noWrap btn-primary btn-label waves-effect waves-light `}>
                                <i className="ri-user-settings-line label-icon align-middle fs-16 ms-2" />
                                Assign
                            </button>
                            </div>
                        </div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                        <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                        <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                            <tr>
                            <th style={{ width:"5%"}} className="text-center">Sr.No.</th>
                            <th style={{ width:"10%"}} className="noWrap">Assigned Date</th>
                            <th className="noWrap">Goal Title</th>
                            <th style={{ width:"10%"}} className="text-center">Grade</th>
                            <th style={{ width:"10%"}} className="text-center noWrap">Start Date</th>
                            <th style={{ width:"10%"}} className="text-center noWrap">End Date</th>
                            <th style={{ width:"10%"}}>Status</th>
                            { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(5) || this.state.decodedData?.includes(3)) && ( 
                            <th  style={{ width:"10%"}} className="text-center">Action</th>)}
                            </tr>
                        </thead>
                        {this.state.rows.length === 0 ? (
                            <tbody>
                            <tr>
                                <td colSpan={11}>
                                <NoRecords />
                                </td>
                            </tr>
                            </tbody>
                        ) :
                            <tbody>
                            {this.state.rows.map((row,idx) => {
                                return (
                                    <tr key={row?.goal_id}>
                                        <td className="text-center">{idx+1}</td>
                                        <td className="noWrap">{row.assigned_date? formatDate(row.assigned_date):"--"}</td>
                                        <td>{row.goal_title}</td>  
                                        <td className="text-center">
                                            <TooltipComponent name={
                                                 row?.goal_grade==="A+"?
                                                    "Outstanding":
                                                    row?.goal_grade==="A"?
                                                    "Excellent":
                                                    row?.goal_grade==="B+"?
                                                    "Very Good":
                                                    row?.goal_grade==="B"?
                                                    "Good":
                                                    row?.goal_grade==="C+"?
                                                    "Satisfactory":
                                                    row?.goal_grade==="C"?
                                                    "Needs Improvement":
                                                    row?.goal_grade==="D"?
                                                    "Poor":
                                                    row?.goal_grade==="F"?
                                                    "Unsatisfactory":
                                                    "--"
                                            } position="bottom">
                                                <div
                                                    style={{ fontSize: "0.8rem", width:"4rem" }}
                                                    // ${row?.goal_grade==="A+"?
                                                    //         "grade-a-pluse":
                                                    //         row?.goal_grade==="A"?
                                                    //         "grade-a":
                                                    //         row?.goal_grade==="B+"?
                                                    //         "grade-b-pluse":
                                                    //         row?.goal_grade==="B"?
                                                    //         "grade-b":
                                                    //         row?.goal_grade==="C+"?
                                                    //         "grade-c-pluse":
                                                    //         row?.goal_grade==="C"?
                                                    //         "grade-c":
                                                    //         row?.goal_grade==="D"?
                                                    //         "grade-d":
                                                    //         row?.goal_grade==="F"?
                                                    //         "grade-f":
                                                    //         "bg-light text-dark"
                                                    //     } 
                                                    className={`bg-light text-dark fw-bold px-1 text-center py-1  rounded-4`}
                                                    >
                                                    {row?.goal_grade || "--"}
                                                </div>
                                            </TooltipComponent>
                                        </td>  
                                        <td className="noWrap">{row.goal_start_date? formatDate(row.goal_start_date):"--"}</td>
                                        <td className="noWrap">{row.goal_end_date? formatDate(row.goal_end_date):"--"}</td>
                                        <td>
                                            {/* <div
                                                style={{ fontSize: "0.65rem" }}
                                                className={` bg-${row?.GoalStatusClasses} ${row?.GoalStatusClasses==="light"? "text-dark":"text-white"} fw-semibold px-1 text-center py-1  rounded-4`}
                                                >
                                                {row?.GoalStatus}
                                            </div> */}
                                            {(row?.goal_status==="0" || row?.goal_status==="1")?
                                                <button
                                                    type="button"
                                                    className={` w-100 noWrap bg-${row?.GoalStatusClasses} ${row?.GoalStatusClasses==="light"? "text-dark":"text-white"}  btn dropdown-toggle dropdown-toggle-split`}
                                                    id="dropdownMenuReference"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                    data-bs-reference="parent"
                                                    style={{ background: "#c7c7c7" }}
                                                >
                                                    {row?.GoalStatus}
                                                </button>:
                                                <button
                                                    type="button"
                                                    className={` w-100 noWrap bg-${row?.GoalStatusClasses} ${row?.GoalStatusClasses==="light"? "text-dark":"text-white"}  btn `}
                                                    style={{ background: "#c7c7c7" }}
                                                >
                                                    {row?.GoalStatus}
                                                </button>
                                            }
                                            {row?.goal_status==="0"?
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuReference">
                                                    <li>
                                                        <button className="dropdown-item" onClick={() => this.handleSelectAllDropdown('Started',row)}>
                                                            Started
                                                        </button>
                                                    </li>
                                                </ul>:
                                                row?.goal_status==="1"?
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuReference">
                                                    <li>
                                                        <button className="dropdown-item" onClick={() => this.handleSelectAllDropdown('In Progress',row)}>
                                                            In Progress
                                                        </button>
                                                    </li>
                                                </ul>:null
                                            }
                                                
                                        </td>
                                        { (this.state.decodedData?.includes(1) || this.state.decodedData?.includes(5) || this.state.decodedData?.includes(3)) && ( 
                                        <td>
                                            <div className="d-flex justify-content-around gap-2">
                                                { this.state.decodedData?.includes(1) && ( 
                                                  <TooltipComponent name="View" position="bottom">
                                                    <button
                                                        onClick={() =>{
                                                            this.getInfo(row);
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-success mr-2 text-center"
                                                        > 
                                                        <i className="ri-file-info-line"></i>
                                                    </button>
                                                </TooltipComponent>)}
                                                { this.state.decodedData?.includes(5) && ( 
                                                  <TooltipComponent name="Logs" position="bottom">
                                                    <button
                                                        onClick={() =>{
                                                            if(!this.state.loadingLogs){
                                                                this.setState({loadingLogs:true},
                                                                    ()=>this.GetGoalsLogList(row))
                                                            }
                                                            
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-secondary mr-2 text-center"
                                                        > 
                                                         {this.state.loadingLogs ? (
                                                            <span
                                                                class="spinner-border flex-shrink-0"
                                                                role="status"
                                                                style={{
                                                                width: "0.8rem",
                                                                height: "0.8rem",
                                                                borderWidth: "2px",
                                                                }}
                                                            >
                                                                <span class="visually-hidden">
                                                                Loading...
                                                                </span>
                                                            </span>
                                                            ) : (
                                                            <i className="ri-file-text-line"></i>
                                                            )}
                                                    </button>
                                                </TooltipComponent>)}
                                                { this.state.decodedData?.includes(3) && ( 
                                                <TooltipComponent name="Send For Review" position="bottom-left">
                                                    <button
                                                        onClick={() =>{
                                                            this.handleRating(row)
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-primary mr-2 text-center"
                                                        > 
                                                        <i className="ri-send-plane-fill"></i>
                                                    </button>
                                                </TooltipComponent>)}
                                            </div>
                                        </td>)}
                                    </tr>
                                );
                            })}
                            </tbody>}
                        </table>
                    </div>
                    <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2" >
                        <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} 
                        className={` d-md-none d-block btn btn-primary btn-label waves-effect right waves-light`}>
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next
                        </button>
                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                            {
                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                            }
                        </div>
                        <div className='col-md-2'>
                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                {this.state.rows?.length>0 && (
                                    <option value={this.state.rows?.length}>
                                    All
                                    </option>
                                )}
                                {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                        Limit {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} 
                        className={` d-md-block d-none btn btn-primary btn-label waves-effect right waves-light`}>
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next
                        </button>
                    </div>
                  </div>
                </div>
                {this.state.goalsModal && (
                    <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} >
                        <div className=" m-auto mt-4 w-modal">
                            <div className="modal-content">
                            <div className="modal-header pb-1">
                                <h5 className="modal-title" id="exampleModalgridLabel">Goal Info</h5>
                                <button type="button"
                                disabled={this.state.postLoading} className="btn-close" onClick={()=>{
                                    this.setState({
                                        goal_id:'',
                                        goalsModal:false,
                                        goal_title:"",
                                        goal_description:"",
                                        pms_cycle_from_date: '',
                                        pms_cycle_to_date:  '',
                                        pms_cycle_start_date: '',
                                        pms_cycle_end_date: '',
                                    })
                                }} aria-label="Close" />
                            </div>
                            <div className="modal-body pt-0">
                                <div className="container mt-2">
                                <form className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="goal_title" className="form-label">Goal Title</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="goal_title"
                                            name="goal_title"
                                            disabled
                                            value={this.state.goal_title}
                                            onChange={(e) => this.handleInputChange(e)}
                                            placeholder="Enter Title"
                                        />
                                        {/* {this.state.errors.goal_title && <div className="text-danger">{this.state.errors.goal_title}</div>} */}
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="goal_title" className="form-label">PMS Cycle Dates</label>
                                        <div  className={`form-control`}>
                                            <span>
                                                {this.state.pms_cycle_start_date} <i className="ri-arrow-left-right-line" /> {this.state.pms_cycle_end_date}
                                            </span>
                                        </div>
                                        {/* {this.state.errors.goal_title && <div className="text-danger">{this.state.errors.goal_title}</div>} */}
                                    </div>                                    
                                    <div className="col-md-12 mt-3">
                                        <label htmlFor="goal_description" className="form-label">Goal Descrisption</label>
                                        <textarea 
                                            className={`form-control`}
                                            id="goal_description"
                                            name="goal_description"
                                            disabled
                                            value={this.state.goal_description}
                                            onChange={(e) => this.handleInputChange(e)}
                                            placeholder="Write Description..."
                                        />
                                        {/* {this.state.errors.goal_description && <div className="text-danger">{this.state.errors.goal_description}</div>} */}
                                    </div>
                                    {this.state.goal_rating_employee && (
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="goal_rating_employee" className="form-label">Self Rating <small className=" text-muted">(Out Of 100)</small></label>
                                            <input
                                                type="text"
                                                className={`form-control`}
                                                id="goal_rating_employee"
                                                name="goal_rating_employee"
                                                disabled
                                                value={this.state.goal_rating_employee}
                                                onChange={(e) => this.handleInputChange(e)}
                                                placeholder="Enter Title"
                                            />
                                            {/* {this.state.errors.goal_rating_employee && <div className="text-danger">{this.state.errors.goal_rating_employee}</div>} */}
                                        </div>
                                    )}
                                    {this.state.goal_submit_remark && (
                                        <div className="col-md-12 mt-3">
                                        <label htmlFor="goal_submit_remark" className="form-label">Remark</label>
                                        <textarea 
                                            className={`form-control`}
                                            id="goal_submit_remark"
                                            name="goal_submit_remark"
                                            disabled
                                            value={this.state.goal_submit_remark}
                                            onChange={(e) => this.handleInputChange(e)}
                                            placeholder="Write Description..."
                                        />
                                        {/* {this.state.errors.goal_submit_remark && <div className="text-danger">{this.state.errors.goal_submit_remark}</div>} */}
                                    </div>
                                    )}
                                </form>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.viewEmployeeGoalsLogs && (
                    <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}  >
                    <div className="m-auto mt-4 w-modal">
                        <div className="modal-content">
                        <div className="modal-header pb-0">
                            <h5 className="modal-title" id="rmModalLabel">Employee Assigned Goals</h5>
                            <button type="button" className="btn-close" onClick={()=> this.setState({ viewEmployeeGoalsLogs:false })} aria-label="Close" />
                        </div>
                        <div className="modal-body pt-0">
                            <h5>Goal Title: {Array.isArray(this.state.employeeGoalsRows) && this.state.employeeGoalsRows.length > 0 ? this.state.employeeGoalsRows[0]?.goal_title:"--"}</h5>
                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                    <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                        <tr>
                                            <th style={{ width:"5%"}} className="text-center">Sr.No.</th>
                                            <th style={{ width:"8%"}} className="text-center">Date</th>
                                            {/* <th>Goal Title</th> */}
                                            <th style={{ width:"10%"}} className="text-center">Status</th>
                                            <th style={{ width:"10%"}} className="text-center noWrap">Employee Rating</th>
                                            <th style={{ width:"10%"}} className="text-center noWrap">RM Rating</th>
                                            <th style={{ width:"5%"}} className="text-center">Grade</th>
                                            <th className="noWrap">Self Remark</th>
                                            <th className="noWrap">RM Remark</th>
                                            {/* <th  style={{ width:"10%"}} className="text-center">Status</th> */}
                                        </tr>
                                    </thead>
                                    {Array.isArray(this.state.employeeGoalsRows) && this.state.employeeGoalsRows.length === 0 ? (
                                        <tbody>
                                        <tr>
                                            <td colSpan={11}>
                                            <NoRecords />
                                            </td>
                                        </tr>
                                        </tbody>
                                    ) :
                                        <tbody>
                                        {Array.isArray(this.state.employeeGoalsRows) && this.state.employeeGoalsRows.map((row,idx) => {
                                            return (
                                            <tr key={row.employee_id}>
                                                <td className="text-center">{idx+1}</td>
                                                <td className="noWrap">{row.created_date? formatDateAndTime(row.created_date)?.split("T")[0]:"--"}</td>
                                                {/* <td>{row.goal_title}</td> */}
                                                <td>
                                                    <div
                                                        style={{ fontSize: "0.65rem" }}
                                                        className={`noWrap bg-${row?.GoalStatusClasses} ${row?.GoalStatusClasses==="light"? "text-dark":"text-white"} fw-semibold px-1 text-center py-1  rounded-4`}
                                                    >
                                                        {row?.GoalStatus}
                                                    </div>
                                                </td>
                                                <td className="text-center">{row?.goal_rating_employee || "--"}</td>
                                                <td className="text-center">{row?.goal_rating_rm || "--"}</td>
                                                <td className="text-center">{row?.goal_grade || "--"}</td>
                                                <td>{row?.goal_submit_remark || "--"}</td>
                                                <td>{row?.goal_rating_remarks_rm || "--"}</td>
                                            </tr>
                                            );
                                        })}
                                        </tbody>}
                                        {/* <tfoot className="table-light">
                                            <tr>
                                            <th colSpan={8}>
                                                <div className="d-flex justify-content-between">
                                                <button
                                                    disabled={
                                                    this.state.prev === false &&
                                                        this.state.loadingList === false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() => this.handlePrev()}
                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                </button>
                                                <div
                                                    className="col-md-4"
                                                    style={{ display: "flex", alignItems: "center" }}
                                                >
                                                    {
                                                    <small>
                                                        Total Records: {this.state.total_records} |
                                                        Total Pages: {this.state.total_pages} |
                                                        Current Page: {this.state.page}
                                                    </small>
                                                    }
                                                </div>
                                                <div className="col-md-2">
                                                    <select
                                                    className="form-select"
                                                    onChange={(e) => this.handleChange(e)}
                                                    >
                                                    {Array.from(
                                                        { length: this.state.total_pages },
                                                        (_, i) => (
                                                        <option
                                                            selected={this.state.page === i + 1}
                                                            key={i}
                                                            value={i + 1}
                                                        >
                                                            Page {i + 1}
                                                        </option>
                                                        )
                                                    )}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select
                                                    className="form-select"
                                                    onChange={this.handleLimitChange}
                                                    value={this.state.limit}
                                                    >
                                                    {limitOptions.map((option) => (
                                                        <option key={option} value={option}>
                                                        Limit {option}
                                                        </option>
                                                    ))}
                                                    </select>
                                                </div>
                                                <button
                                                    disabled={
                                                    this.state.next === false &&
                                                        this.state.loadingList === false
                                                        ? true
                                                        : false
                                                    }
                                                    type="button"
                                                    onClick={() => this.handleNext()}
                                                    className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                >
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                    Next
                                                </button>
                                                </div>
                                            </th>
                                            </tr>
                                        </tfoot> */}
                                </table>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                )}
                {this.state.sendGoalModal && (
                    <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} >
                        <div className="m-auto mt-4 w-modal">
                            <div className="modal-content">
                            <div className="modal-header pb-0">
                                <h5 className="modal-title" id="exampleModalgridLabel">Send Goal For Review</h5>
                                <button type="button"
                                disabled={this.state.postLoading} className="btn-close" onClick={()=>{
                                    this.setState({
                                        sendGoalModal:false,
                                        goal_assign_id: "",
                                        goal_rating_employee: '',
                                        goal_submit_remark: '',
                                        pms_cycle_from_date: '',
                                        pms_cycle_to_date:  '',
                                        pms_cycle_start_date: '',
                                        pms_cycle_end_date: '',
                                    })
                                }} aria-label="Close" />
                            </div>
                            <div className="modal-body pt-0">
                                <div className="container mt-2">
                                <form className="row">
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="goal_title" className="form-label">Goal Title</label>
                                    <input
                                        type="text"
                                        className={`form-control`}
                                        id="goal_title"
                                        name="goal_title"
                                        disabled
                                        value={this.state.goal_title}
                                        onChange={(e) => this.handleInputChange(e)}
                                        placeholder="Enter Title"
                                    />
                                    {/* {this.state.errors.goal_title && <div className="text-danger">{this.state.errors.goal_title}</div>} */}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="goal_title" className="form-label">PMS Cycle Dates</label>
                                    <div  className={`form-control`}>
                                        <span>
                                            {this.state.pms_cycle_start_date} <i className="ri-arrow-left-right-line" /> {this.state.pms_cycle_end_date}
                                        </span>
                                    </div>
                                    {/* {this.state.errors.goal_title && <div className="text-danger">{this.state.errors.goal_title}</div>} */}
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="goal_rating_employee" className="form-label">Self Rating <small className=" text-muted">(Out Of 100)</small>
                                        <span
                                            style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        className={`form-control`}
                                        id="goal_rating_employee"
                                        name="goal_rating_employee"
                                        value={this.state.goal_rating_employee}
                                        onChange={(e) => this.handleInputChange(e)}
                                        placeholder="Enter Rating"
                                    />
                                    {this.state.errors.goal_rating_employee && <div className="text-danger">{this.state.errors.goal_rating_employee}</div>}
                                </div>
                                <div className="col-md-6 mt-3">
                                <div className="row col-md-12">
                                    <div className='col-md-6'>
                                        <label htmlFor="pms_cycle_from_date" className="form-label">Goal Start date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="pms_cycle_from_date"
                                            name="pms_cycle_from_date"
                                            disabled
                                            value={this.state.pms_cycle_from_date}
                                            // onChange={(e) => this.handleInputChange(e)}
                                            placeholder="Start Date"
                                        />                                    
                                    </div>
                                    <div className='col-md-6'>
                                        <label htmlFor="pms_cycle_to_date" className="form-label">Goal End date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="pms_cycle_to_date"
                                            name="pms_cycle_to_date"
                                            disabled
                                            value={this.state.pms_cycle_to_date}
                                            // onChange={(e) => this.handleInputChange(e)}
                                            placeholder="End Date"
                                        />                                    
                                    </div>
                                </div>
                                    
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="goal_submit_remark" className="form-label">Remark
                                        <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                                    </label>
                                    <textarea 
                                        className={`form-control`}
                                        id="goal_submit_remark"
                                        name="goal_submit_remark"
                                        value={this.state.goal_submit_remark}
                                        onChange={(e) => this.handleInputChange(e)}
                                        placeholder="Write Remark..."
                                    />
                                    {this.state.errors.goal_submit_remark && <div className="text-danger">{this.state.errors.goal_submit_remark}</div>}
                                </div>
                                </form>
                                <div className="col-md-12" style={{ marginTop: "30px" }}>
                                    {!this.state.postLoading ?
                                            <button
                                            disabled={!this.state.goal_rating_employee || !this.state.goal_submit_remark}
                                            className={`btn noWrap btn-primary btn-label waves-effect waves-light `}
                                            onClick={()=>{
                                                if(!this.state.postLoading){
                                                    this.setState({postLoading:true},
                                                        ()=>{
                                                            this.handleSubmit()
                                                        }
                                                    ); 
                                                }
                                            }}
                                            >
                                                <i className={`ri-send-plane-line label-icon align-middle fs-16`} />{"Send"}
                                            </button> :
                                            <button className="btn btn-primary btn-load">
                                                <span className="d-flex align-items-center">
                                                    <span className="spinner-border flex-shrink-0" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </span>
                                                    <span className="flex-grow-1 ms-2">
                                                        Sending...
                                                    </span>
                                                </span>
                                            </button>
                                        }
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(EmployeePMS);
